import { render, staticRenderFns } from "./RegisterUserModal.vue?vue&type=template&id=2bb7606e&scoped=true"
import script from "./RegisterUserModal.vue?vue&type=script&lang=js"
export * from "./RegisterUserModal.vue?vue&type=script&lang=js"
import style0 from "./RegisterUserModal.vue?vue&type=style&index=0&id=2bb7606e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb7606e",
  null
  
)

export default component.exports